import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../firebase";

function Service() {
  const { category } = useParams();
  const [categoryData, setCategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const servicesPerPage = 6;

  const titleCase = (data) => {
    let arr = [];
    let capitalizeNext = false;
    if (data.includes("-")) {
      for (const letter of data) {
        if (letter === "-") {
          arr.push(" ");
          capitalizeNext = true; // Set the flag to capitalize the next letter
        } else {
          if (capitalizeNext) {
            arr.push(letter.toUpperCase());
            capitalizeNext = false; // Reset the flag after capitalization
          } else {
            arr.push(letter);
          }
        }
      }
      arr[0] = arr[0].toUpperCase();
    } else {
      for (const letter of data) {
        arr.push(letter);
      }
      arr[0] = arr[0].toUpperCase();
    }
    return arr.join("");
  };
  const cat = titleCase(category);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const servicesRef = collection(firestore, "services");
        const servicesQuery = query(
          servicesRef,
          where("category", "==", cat) // Match the category (uppercase) with the URL parameter
        );
        const querySnapshot = await getDocs(servicesQuery);

        // const data = [];

        // querySnapshot.forEach((doc) => {
        //   data.push(doc.data());
        // });

      const data = querySnapshot.docs.map(doc => ({
        id: doc.id, // Capture the document ID
        ...doc.data() // Spread the rest of the document data
      }));

        setCategoryData(data);
        console.log(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [category, cat]);

  const indexOfLastService = currentPage * servicesPerPage;
  const indexOfFirstService = indexOfLastService - servicesPerPage;
  const currentServices = categoryData.slice(
    indexOfFirstService,
    indexOfLastService
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <main id="service">
      <div className="bg"></div>
      <section className="details">
        <h2>{cat}</h2>
        {isLoading ? (
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#cd5c5e"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        ) : (
          <div className="cards flex wrap">
            {categoryData.length === 0
              ? "No services are offered in this category"
              : currentServices.map((service) => (
                  <div
                    className="card flex column align-center justify-between"
                    key={service.name}
                  >
                    <h3>{service.name}</h3>
                    <p>{service.description}</p>
                    <div className="flex align-center justify-center full-width gap-2">
                      <a href={`${category}/${service.id}`} className="button button-primary">
                        View
                      </a>
                      <a href="." className="button button-primary">
                        Book Now
                      </a>
                    </div>
                  </div>
                ))}
          </div>
        )}
        {categoryData.length > servicesPerPage && (
          <div className="pagination flex align-center justify-center">
            {Array.from(
              { length: Math.ceil(categoryData.length / servicesPerPage) },
              (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => paginate(index + 1)}
                  className={`page-button ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </button>
              )
            )}
          </div>
        )}
      </section>
    </main>
  );
}

export default Service;
